export default __webpack_public_path__ + "static/media/rostov_na_donu.525ac36b.pdf";